import { ChangeDetectorRef, Component, inject, OnInit, signal } from '@angular/core';
import { MaterialModule } from '../../shared/material/material.module';
import { DeviceDetectorService } from 'ngx-device-detector';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Faq, FaqControllerService } from '../../core/generated';
import { GroupFaq } from '../../shared/enums';
import { ContainerComponent } from '../../shared/container/container.component';
import { RouterLink } from '@angular/router';

interface FaqGroup {
  groupName: string;
  faqs: Faq[];
}

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [MaterialModule, ContainerComponent, RouterLink],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent implements OnInit {
  private deviceService = inject(DeviceDetectorService);
  private faqService = inject(FaqControllerService);
  private cdr = inject(ChangeDetectorRef);

  faqs: Faq[] = [];
  faqGroups: FaqGroup[] = [];
  isMobile = this.deviceService.isMobile();
  isLoading = true;
  readonly panelOpenState = signal(false);

  // Mapeia a chave do enum (vinda do backend) para o label descritivo
  private readonly groupLabelMap: Record<string, string> = {
    PLATAFORMA:      GroupFaq.PLATAFORMA,
    USUARIO:         GroupFaq.USUARIO,
    SEGURANCA:       GroupFaq.SEGURANCA,
    FUNCIONALIDADES: GroupFaq.FUNCIONALIDADES,
    PAGAMENTOS:      GroupFaq.PAGAMENTOS,
    TECNICO:         GroupFaq.TECNICO,
  };

  // Ordem de exibição dos grupos
  private readonly groupOrder = Object.keys(this.groupLabelMap);

  async ngOnInit(): Promise<void> {
    try {
      const result = await firstValueFrom(
        this.faqService.findAll8().pipe(
          catchError(() => of([] as Faq[]))
        )
      );

      if (result instanceof Blob) {
        const text = await result.text();
        this.faqs = JSON.parse(text) as Faq[];
      } else {
        this.faqs = Array.isArray(result) ? result.filter(f => !!f) : [];
      }
    } catch {
      this.faqs = [];
    }

    this.buildFaqGroups();
    this.isLoading = false;
    this.cdr.detectChanges();
  }

  private buildFaqGroups(): void {
    const map = new Map<string, Faq[]>();

    this.faqs.forEach(faq => {
      const raw = faq?.group?.trim();
      const key = raw?.toUpperCase();

      if (key && this.groupLabelMap[key]) {
        if (!map.has(key)) map.set(key, []);
        map.get(key)!.push(faq);
      } else {
        console.warn('[FAQ] grupo não mapeado ou ausente:', raw);
      }
    });

    this.faqGroups = this.groupOrder
      .filter(key => map.has(key) && map.get(key)!.length > 0)
      .map(key => ({
        groupName: this.groupLabelMap[key],
        faqs: map.get(key)!
      }));

  }
}
